import { defineStore } from "pinia";
import { type ConnectionStatus, Network } from "@capacitor/network";
import { ref } from "vue";

export const useConnectionStore = defineStore("connection", () => {
  const connectionStatus = ref<null | ConnectionStatus>(null);

  Network.getStatus().then((networkonnectionStatus) => {
    connectionStatus.value = networkonnectionStatus;
  });

  Network.addListener("networkStatusChange", (networkConnecctionStatus) => {
    connectionStatus.value = networkConnecctionStatus;
  });

  return {
    connectionStatus,
  };
});
